import React, { useCallback, useState } from "react";
import { resetPasswordRequest } from "./../../api";
import { CheckCircle } from "react-feather";
import { useIntl } from "react-intl";
import "./styles.scss";

function ChangePassword({ setError }) {
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const { formatMessage } = useIntl();

  const handleChangePassword = useCallback(async () => {
    setIsLoading(true);

    if (password !== confirmPassword) {
      setError(formatMessage({ id: "senhas-diferentes" }));
      setIsLoading(false);
      return;
    }

    try {
      await resetPasswordRequest(
        localStorage.getItem("access_token"),
        password
      );

      setIsSuccess(true);
    } catch (e) {
      setPassword("");
      setConfirmPassword("");
      let errorMessage = formatMessage({ id: "erro-api" });
      if (e.response?.data) {
        errorMessage = e.response.data.message;
      }

      setError(errorMessage);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  }, [confirmPassword, password, setError, formatMessage]);

  return (
    <>
      <h1>Alterar Senha</h1>
      <div className="change-password-form">
        <div className="tile is-ancestor">
          <div className="tile is-6 is-vertical">
            <p>{formatMessage({ id: "texto-alterar-senha" })}:</p>
            <input
              type="password"
              placeholder={formatMessage({ id: "senha" })}
              onChange={e => setPassword(e.target.value)}
            />
            <input
              type="password"
              placeholder={formatMessage({ id: "confirmar-senha" })}
              onChange={e => setConfirmPassword(e.target.value)}
            />
            {isSuccess && (
              <div className="modified-success">
                <CheckCircle size={20} />
                <p>Senha modificada com sucesso</p>
              </div>
            )}
            <button
              type="button"
              className={`button primary ${isLoading ? "is-loading" : ""}`}
              aria-label="confirm-change-button"
              onClick={handleChangePassword}
            >
              {formatMessage({ id: "Salvar" })}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
